import classNames from 'classnames';
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { createUseStyles } from 'react-jss';
import _ from 'lodash';
import { BsCheckCircleFill } from 'react-icons/bs';
import { layoutDefaults } from '../../utils/layout-defaults';

const animationEnter = 'animate__animated animate__bounceIn animate__delay-1s';
const animationButton =
  'animate__animated animate__pulse animate__faster animate__delay-1s';

function ModalBodyButton({
  icon,
  onClick,
  onPrepareForClick,
  disabled,
  selected,
  children,
  className,
  emphasisIndex,
  emphasisDelay,
}) {
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const handleOnClick = () => {
    const result = onPrepareForClick?.call(this) ?? 0;

    if (_.isBoolean(result) && !result) {
      return;
    }

    setLoading(true);

    // _.setTimeout(() => {
    //   onClick?.call(this, setLoading);
    // }, result);

    _.delay(() => {
      onClick?.call(this, setLoading);
    }, result);
  };

  const containerDelay = () =>
    `${emphasisDelay / 1000 + (emphasisIndex * 200) / 1000}s`;

  const iconDelay = () =>
    `${(emphasisDelay + 190) / 1000 + (emphasisIndex * 200) / 1000}s`;

  return (
    <Button
      style={{
        backgroundColor: '#fffafa',
        '--animate-delay': containerDelay(),
      }}
      className={classNames(className, classes.container, animationButton)}
      size="md"
      disabled={disabled || loading}
      onClick={handleOnClick}
    >
      <div className={classes.button}>
        <div className={classes.buttonLeft}>
          {icon && (
            <img
              src={icon}
              className={classNames(classes.logo, animationEnter)}
              style={{
                '--animate-delay': iconDelay(),
              }}
              alt="website logo"
            />
          )}
          {children}
        </div>

        {loading && <Spinner animation="border" className={classes.spinner} />}

        {selected && !loading && (
          <BsCheckCircleFill
            className={classNames(classes.spinner, classes.selected)}
          />
        )}
      </div>
    </Button>
  );
}

const useStyles = createUseStyles({
  container: {
    width: '100%',
    textAlign: 'left',
  },
  button: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonLeft: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  logo: {
    height: 28,
    width: 28,
    marginRight: layoutDefaults.smallHorizontalMargin,
  },
  spinner: {
    position: 'absolute',
    color: layoutDefaults.buttonText,
    fontSize: layoutDefaults.fontSize,
    right: layoutDefaults.smallHorizontalMargin,
    height: 26,
    width: 26,
  },
  selected: {
    color: layoutDefaults.buttonText,
  },
});

export { ModalBodyButton };
